var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3 8V6H21V8H3ZM3 13H21V11H3V13ZM3 18H21V16H3V18Z","fill":_vm.fill_color,"fill-opacity":_vm.opacity}})])
}
var staticRenderFns = []

export { render, staticRenderFns }